import './vant'
(function() {
    const baseSize = 37.5; 
    function setRemUnit() {
      const scale = document.documentElement.clientWidth / (baseSize*10); 
      document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px';
    }
    setRemUnit();
    window.onresize = setRemUnit; 
  })();